import { CardHeader, Grid2 } from '@mui/material'
import { memo } from 'react'

import MembershipDataTable from './MembershipDataTable'

const MembershipFeatures = ({ t, tiers, currentTier }) => {
  return (
    <>
      <Grid2 size={{ xs: 12 }}>
        <CardHeader
          title={t('membership.membership-status-overview')}
          subheader={t('membership.membership-status-overview-desc')}
          sx={{ p: 0, mb: 2 }}
        />
        <MembershipDataTable currentTier={currentTier} tiers={tiers} t={t} />
      </Grid2>
    </>
  )
}

export default memo(MembershipFeatures)
